module.exports = __webpack_public_path__ + "img/ico-menu-contextuel.f67fb923.svg";